import { IResource } from '../types';
import { useDebugValue, useMemo } from 'react';
import { sumBy } from 'lodash';
import { useCalendarStoreSelector } from './useCalendarStoreSelector';

type Props = {
	resourceGroups?: Record<number, number[]> | null;
};

export const useResources = (props?: Props) => {
	useDebugValue('useResources');

	const resources: IResource[] = useCalendarStoreSelector(state => state.resources);

	const filteredResources: IResource[] = useMemo(() => {
		return resources.map(resource => {
			return {
				...resource,
				children: resource.children.filter(
					child =>
						!props?.resourceGroups?.[resource.id]?.length || props?.resourceGroups?.[resource.id]?.includes(child.id)
				),
			};
		});
	}, [resources, props?.resourceGroups]);

	const columnsCount: number = useMemo(() => {
		return sumBy(filteredResources, space => space.children?.length || 1);
	}, [filteredResources]);

	return {
		resources: filteredResources,
		columnsCount,
	};
};
